module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flower-shop_1a6843.jpg";